/**
 * Dependencies.
 */
import { AxiosRequestConfig } from 'axios';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import headersBlacklistConstant from '@/modules/main/constants/headers-blacklist.constant';
import { mainStore } from '@/modules/main/store';

/**
 * Component.
 */
@Component({ name: 'app-scene' })
export default class extends Vue {
  /**
   * Property `orderCode`.
   */
  orderCode = null;

  /**
   * Getter order.
   */
  get order() {
    return mainStore.orderCode
      ? `${this.i18n('MAIN.MESSAGES.ORDER')} ${mainStore.orderCode}`
      : this.orderCode;
  }

  /**
   * Lifecycle created hook.
   */
  created() {
    this.handleDistributionCenterCodeHeader();
  }

  /**
   * Handle distribution center code header.
   */
  handleDistributionCenterCodeHeader() {
    this.$kit.http.addRequestInterceptor((config: AxiosRequestConfig) => {
      const { distributionCenterCode = null } = mainStore || {};

      if (
        distributionCenterCode &&
        !headersBlacklistConstant.DC_HEADER.some(regex =>
          regex.test(config.url)
        )
      ) {
        config.headers = {
          ...config.headers,
          DistributionCenterCode: distributionCenterCode
        };
      }

      return config;
    });
  }

  /**
   * Handle view tracking.
   */
  handleViewTracking() {
    const { name = null, params = null, path = '' } = this.$route || {};
    const { key = null } = params || {};

    if (key && path.startsWith('/t/') && name !== 'Tracking') {
      this.$router.push({
        name: 'Tracking',
        params: {
          key
        }
      });
    }
  }

  /**
   * Handle survey order.
   */
  handleSurveyOrder({ orderCode }: { orderCode: string }) {
    this.orderCode = orderCode;
  }
}
